import React from 'react';
import { Card, Tag, Space } from 'antd';

interface Test {
  id: string;
  title: string;
  description: string;
  file_path: string;
  file_type: string;
  questions?: any[];
}

interface TestPreviewProps {
  test: Test;
}

const TestPreview: React.FC<TestPreviewProps> = ({ test }) => {
  const getFileIcon = (fileType: string) => {
    if (fileType.includes('pdf')) return '📄';
    if (fileType.includes('image')) return '🖼️';
    if (fileType.includes('word') || fileType.includes('document')) return '📝';
    return '📁';
  };

  const getFileTypeColor = (fileType: string) => {
    if (fileType.includes('pdf')) return 'red';
    if (fileType.includes('image')) return 'green';
    if (fileType.includes('word') || fileType.includes('document')) return 'blue';
    return 'default';
  };

  return (
    <div>
      <Card title="Test Information" style={{ marginBottom: '20px' }}>
        <div style={{ marginBottom: '15px' }}>
          <h3>{test.title}</h3>
          {test.description && (
            <p style={{ color: '#666', marginTop: '10px' }}>{test.description}</p>
          )}
        </div>
        
        {test.file_path && (
          <div style={{ marginBottom: '15px' }}>
            <Space>
              <span style={{ fontSize: '20px' }}>{getFileIcon(test.file_type)}</span>
              <Tag color={getFileTypeColor(test.file_type)}>
                {test.file_type.split('/')[1]?.toUpperCase() || 'FILE'}
              </Tag>
            </Space>
          </div>
        )}
      </Card>

      {test.questions && test.questions.length > 0 && (
        <Card title={`Question List (${test.questions.length} questions)`}>
          {test.questions.map((question, index) => (
            <Card 
              key={question.id || index}
              size="small" 
              style={{ marginBottom: '15px' }}
            >
              <div>
                <p><strong>Question {index + 1}:</strong> {question.question_text}</p>
                
        {question.question_type === 'multiple_choice' && question.options && (
          <div style={{ marginTop: '10px' }}>
            <strong>Options:</strong>
            <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
              {(Array.isArray(question.options) ? question.options : JSON.parse(question.options || '[]')).map((option: string, optIndex: number) => (
                <li key={optIndex}>
                  {String.fromCharCode(65 + optIndex)}. {option}
                  {option === question.correct_answer && (
                    <Tag color="green" style={{ marginLeft: '10px' }}>
                      Correct Answer
                    </Tag>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
                
                {question.question_type === 'true_false' && (
                  <div style={{ marginTop: '10px' }}>
                    <strong>Correct Answer:</strong> 
                    <Tag color={question.correct_answer === 'true' ? 'green' : 'red'} style={{ marginLeft: '10px' }}>
                      {question.correct_answer === 'true' ? 'True' : 'False'}
                    </Tag>
                  </div>
                )}
                
                {question.question_type === 'fill_blank' && (
                  <div style={{ marginTop: '10px' }}>
                    <strong>Correct Answer:</strong> 
                    <Tag color="blue" style={{ marginLeft: '10px' }}>
                      {question.correct_answer}
                    </Tag>
                  </div>
                )}
                
                <div style={{ marginTop: '10px' }}>
                  <Space>
                    <Tag color="blue">Points: {question.points}</Tag>
                    <Tag color="orange">Type: {
                      question.question_type === 'multiple_choice' ? 'Multiple Choice' :
                      question.question_type === 'true_false' ? 'True/False' :
                      question.question_type === 'fill_blank' ? 'Fill in the Blank' : 'Unknown'
                    }</Tag>
                    {question.knowledge_points && (
                      <Tag color="purple">Knowledge Point: {question.knowledge_points}</Tag>
                    )}
                  </Space>
                </div>
              </div>
            </Card>
          ))}
        </Card>
      )}

      {(!test.questions || test.questions.length === 0) && (
        <Card>
          <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            No questions yet, please add questions first
          </div>
        </Card>
      )}
    </div>
  );
};

export default TestPreview;
